if (!customElements.get('km-product-navigation')) {
  customElements.define('km-product-navigation', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.viewer = this.gallery.querySelector('.product__media-list');
      this.mobile = window.matchMedia('(max-width: 989px), (max-aspect-ratio: 1)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      // The arrow is the pointer in the two edge zones; the center still opens image zoom.
      this.dataset.cursorReady = '';
      this.cursorButtons = [...this.querySelectorAll('button[data-direction]')];
      const hideCursor = () => {
        cancelAnimationFrame(this.cursorFrame);
        this.cursorButtons.forEach((button) => button.classList.remove('is-cursor-active'));
      };
      this.cursorButtons.forEach((button) => {
        const moveCursor = (event) => {
          if (event.pointerType !== 'mouse' || this.mobile.matches) return;
          cancelAnimationFrame(this.cursorFrame);
          this.cursorFrame = requestAnimationFrame(() => {
            const rect = button.getBoundingClientRect();
            button.style.setProperty('--cursor-x', `${event.clientX - rect.left}px`);
            button.style.setProperty('--cursor-y', `${event.clientY - rect.top}px`);
            button.classList.add('is-cursor-active');
          });
        };
        button.addEventListener('pointerenter', moveCursor, options);
        button.addEventListener('pointermove', moveCursor, options);
        button.addEventListener('pointerleave', hideCursor, options);
      });
      this.addEventListener('keydown', hideCursor, options);
      window.addEventListener('blur', hideCursor, options);
      window.addEventListener('scroll', hideCursor, { ...options, passive: true });
      window.addEventListener('resize', hideCursor, options);
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        const items = [...this.viewer.querySelectorAll(':scope > .product__media-item[data-media-id]')].filter((item) =>
          !item.classList.contains('product__media-item--variant') || item.classList.contains('is-active')
        );
        const index = items.findIndex((item) => item.classList.contains('is-active'));
        const next = (index + Number(button.dataset.direction) + items.length) % items.length;
        if (items[next]) this.gallery.setActiveMedia(items[next].dataset.mediaId, false);
      }, options);
      // Native scroll snap owns the gesture. Synchronize media and thumbnails only after it settles.
      this.viewer.addEventListener('scroll', () => {
        clearTimeout(this.settleTimer);
        if (this.mobile.matches) this.settleTimer = setTimeout(() => this.syncSettledSlide(), 160);
      }, { ...options, passive: true });
      this.viewer.addEventListener('scrollend', () => this.syncSettledSlide(), options);
      // Dawn pauses every video when gallery media changes. Resume the muted feature loops as they enter view.
      this.lowerMediaObserver = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            target.play().catch(() => {});
          } else target.pause();
        });
      }, { threshold: 0.15 });
      document.querySelectorAll('.km-pdp-desktop-section video[muted]').forEach((video) => this.lowerMediaObserver.observe(video));
    }

    syncSettledSlide() {
      clearTimeout(this.settleTimer);
      if (!this.mobile.matches) return;
      const items = [...this.viewer.querySelectorAll(':scope > .product__media-item[data-media-id]')].filter((item) => item.offsetWidth > 0);
      const nearest = items.reduce((current, item) =>
        !current || Math.abs(item.offsetLeft - this.viewer.scrollLeft) < Math.abs(current.offsetLeft - this.viewer.scrollLeft)
          ? item : current, null);
      if (nearest && !nearest.classList.contains('is-active')) this.gallery.setActiveMedia(nearest.dataset.mediaId, false);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.lowerMediaObserver?.disconnect();
      cancelAnimationFrame(this.cursorFrame);
      clearTimeout(this.settleTimer);
    }
  });
}
